import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ApiKeysPage from './pages/ApiKeysPage'
import EntraMfaPage from './pages/EntraMfaPage'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<ApiKeysPage />} />
        <Route path="entra-mfa" element={<EntraMfaPage />} />
      </Route>
    </Routes>
  )
}

export default App
